import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const STRESS_CONFIG = {
  High: {
    color: "#FF6445",
    height: { open: "72px", closed: "178px" },
  },
  Moderate: {
    color: "#FFE882",
    height: { open: "94px", closed: "200px" },
  },
  Low: {
    color: "#C8EDF5",
    height: { open: "64px", closed: "160px" },
  },
};

function StressChart({ stressChart, page, handleOpen }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", overflowX: "auto", gap: 1 }}>

      {stressChart?.length == 0 && <Box sx={{ height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '10px' }}>No data available</Typography>
      </Box>}
      {/* Bars */}
      <Box sx={{
        display: "flex", justifyContent: "center", overflowX: 'auto', flex: 1,
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}>
        {stressChart?.map((data, index) => {
          const config = STRESS_CONFIG[data.answer];
          if (!config) return null;

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                minWidth: handleOpen ? '12px' : "28px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                mx: handleOpen ? 0.2 : 0.4,
              }}
            >
              {/* Bar */}
              <Box
                sx={{
                  height: handleOpen ? config.height.open : config.height.closed,
                  width: handleOpen ? "7px" : "14px",
                  backgroundColor: config.color,
                  borderRadius: 10,
                  boxShadow: 3,
                  marginBottom: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {data.hasDonePss && (
                  <Box
                    sx={{
                      width: 4,
                      height: 4,
                      backgroundColor: "#FFFFFF",
                      border: "0.2px solid #1599EA",
                      borderRadius: "100%",
                    }}
                  />
                )}
              </Box>

              {/* Date */}
              <Typography fontSize={handleOpen ? "8px" : "10px"} sx={{
                color: "#000", fontWeight: 'bold'
              }}>
                {moment(data.date).format("DD MMM")}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* Legend */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: 'space-evenly',
          alignItems: "center",
          // width: "100%",
          marginTop: 1,
        }}
      >
        {/* High */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#FF6445" handleOpen={handleOpen} />
          <LegendText label="High Stress" handleOpen={handleOpen} />
        </Box>


        {/* Medium */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#FFE882" handleOpen={handleOpen} />
          <LegendText label="Moderate Stress" handleOpen={handleOpen} />
        </Box>


        {/* Low */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#C8EDF5" handleOpen={handleOpen} />
          <LegendText label="Low Stress" handleOpen={handleOpen} />
        </Box>

        {/* PSS */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#FFFFFF" border="0.2px solid #1599EA" handleOpen={handleOpen} />
          <LegendText label="PSS" handleOpen={handleOpen} />
        </Box>
      </Box>
    </Box>
  );
}

const Dot = ({ color, border, handleOpen }) => (
  <Box
    sx={{
      width: handleOpen ? 5 : 15,
      height: handleOpen ? 5 : 15,
      borderRadius: "100%",
      backgroundColor: color,
      border: border || "none",
      marginRight: 0.5,
    }}
  />
);

const LegendText = ({ label, handleOpen }) => (
  <Typography fontSize={handleOpen ? "10px" : "13px"} marginRight={1}>
    {label}
  </Typography>
);

export default StressChart;
